import React from 'react';
import PropTypes from 'prop-types';

const DesignSkills = ({ type }) => {
  if (type === 'freelancer') {
    return (
      <>
        <li>
          <a href="/jobs/graphic-designers">Graphic design jobs</a>
        </li>
        <li>
          <a href="/jobs/ui-designers">UI design jobs</a>
        </li>
        <li>
          <a href="/jobs/ux-designers">UX design jobs</a>
        </li>
        <li>
          <a href="/jobs/web-designers">Web design jobs</a>
        </li>
        <li>
          <a href="/jobs/brand-designers">Brand design jobs</a>
        </li>
        <li>
          <a href="/jobs/logo-designers">Logo design jobs</a>
        </li>
        <li>
          <a href="/jobs/illustrators">Illustrator jobs</a>
        </li>
        <li>
          <a href="/jobs/pitch-deck-designers">Pitch deck design jobs</a>
        </li>
        <li>
          <a href="/jobs/creative-strategists">Creative strategist jobs</a>
        </li>
        <li>
          <a href="/jobs/ad-designers">Ad design jobs</a>
        </li>
      </>
    );
  }

  return (
    <>
      <li>
        <a href="/find/graphic-designers">Graphic designers</a>
      </li>
      <li>
        <a href="/find/ui-designers">UI designers</a>
      </li>
      <li>
        <a href="/find/ux-designers">UX designers</a>
      </li>
      <li>
        <a href="/find/web-designers">Web designers</a>
      </li>
      <li>
        <a href="/find/brand-designers">Brand designers</a>
      </li>
      <li>
        <a href="/find/logo-designers">Logo designers</a>
      </li>
      <li>
        <a href="/find/illustrators">Illustrators</a>
      </li>
      <li>
        <a href="/find/pitch-deck-designers">Pitch deck designers</a>
      </li>
      <li>
        <a href="/find/creative-strategists">Creative strategists</a>
      </li>
      <li>
        <a href="/find/ad-designers">Ad designers</a>
      </li>
      <li>
        <a href="/find/banner-ad-designers">Banner ad designers</a>
      </li>
      <li>
        <a href="/find/product-designers">Product designers</a>
      </li>
    </>
  );
};

DesignSkills.propTypes = {
  type: PropTypes.string.isRequired,
};

export default DesignSkills;
